
import Session from "./session"

class Product {
	constructor(request) {
		this.request = request
		this.endpoint = 'product'
	}

	/* Search Products via category
	 * maybe should rename this function to searchCategory since its not obvious this is for searching through a category
	 */
	Search(category, fail ) {
		//fail was just for testing error handling
		/* api used before switching to static json list
		const body = {
			"categoryurl":category
		}

		return this.request.send(
			`${this.endpoint}/search/`,
			'POST',
			body,
			undefined,
			fail
		)
		*/
		return this.request.requestData(`https://cdn.ngnw.ph/lists/product/category/${category}.json`)
	}

	SearchTop(category) {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/product/category/top/${category}.json`)
	}

	filterProducts (products, userExclusiveList) {
		const filteredProducts = products.filter((product) => {
			const { meta, exclusive } = product;

			let priceval = 0;

			if (meta) {
				priceval = meta.display_price.with_tax.amount;
			}

			let itemHidden = true;

			if (priceval > 0) {
				itemHidden = false;
			} else if (exclusive.length === 0) {
				itemHidden = false;
			} else {
				for (const item of exclusive) {
					if (userExclusiveList.includes(item.code)) {
						itemHidden = false;
					} else if (!item.hasOwnProperty('hidden')) {
						itemHidden = false;
					} else if (!item.hidden) {
						itemHidden = false;
					}

					if (!itemHidden) break;
				}
			}

			return !itemHidden;
		})

		return filteredProducts;
	}

	async SearchProducts (parameters, batch=0) {
		let results = [];

		let hasOrgIdParam = parameters.hasOwnProperty("organizationId");
		let hasSearchTextParam = parameters.hasOwnProperty("searchtext");
		let hasCategoryParam = parameters.hasOwnProperty("categoryurl");

		if (hasOrgIdParam && (hasSearchTextParam || hasCategoryParam)) {
			results = await this.SearchMultiple(parameters);
		} else if (hasOrgIdParam) {
			results = await this.SearchOrganizationCategoryProduct(parameters.organizationId);
		} else if (hasSearchTextParam) {
			results = await this.SearchText(parameters.searchtext);
		}

		let userExclusiveList = [];

		if (localStorage.getItem("userExclusiveList")) {
			userExclusiveList = JSON.parse(localStorage.getItem("userExclusiveList")).data;
		}
		let filteredResults = [...results];

		if (hasSearchTextParam || hasCategoryParam) {
			filteredResults = this.filterProducts(results, userExclusiveList);
		} else if (hasOrgIdParam) {
			for (const category of filteredResults) {
				category.productlist = this.filterProducts(category.productlist, userExclusiveList);
			}
		}
		
		return filteredResults;
	}

	SearchText(text) {
		const body = {
			"searchtext":text
		}
		return this.request.send(
			//`${this.endpoint}/search/`,
			`search/${this.endpoint}/`,
			'POST',
			body
		)
	}

	SearchOrganizationFulfillment(id) {
		/* api used before switching to static json list
		const body = {
			"organizationId":id,
		}
		return this.request.send(
			`${this.endpoint}/search/`,
			'POST',
			body
		)
		*/
		return this.request.requestData(`https://cdn.ngnw.ph/lists/organization/fulfillment/${id}.json`)
	}

	SearchOrganizationProduct(id) {
		/* api used before switching to static json list
		const body = {
			"organizationId":id,
		}
		return this.request.send(
			`${this.endpoint}/search/`,
			'POST',
			body
		)
		*/
		return this.request.requestData(`https://cdn.ngnw.ph/lists/product/organization/${id}.json`)
	}

	SearchOrganizationCategoryProduct(id) {
		/* 
		 * Sample response:
		 * [
		 * 		{
		 * 			name: <category_name>,
		 * 			url: <category_url>,
		 * 			productlist: [ {..product data }, ... ]
		 * 		},
		 * 		...
		 * ]
		 */
		return this.request.requestData(`https://cdn.ngnw.ph/lists/product/organizationcategory/${id}.json`);
	}

	SearchBlogProduct(id) {
		/*
			No graphql API for the product in recipes/blog pages
		*/
		return this.request.requestData(`https://cdn.ngnw.ph/lists/product/recipe/${id}.json`)
	}

	SearchMultiple(query) {
		const body = {
			query
		}
		return this.request.send(
			//`${this.endpoint}/search/`,
			`search/${this.endpoint}/`,
			'POST',
			body
		)
	}

	async GetProductSectionExclusive(url, username) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
			url: url
		}
		return this.request.send(
			`${this.endpoint}/view`,
			'POST',
			body,
			jwtToken
		)
	}

	GetProductSection(url) {
		return this.request.requestData(
			`https://cdn.ngnw.ph/details/product/${url}.json`
		)
	}
}


export default Product